import { createSelector } from 'reselect';
import getQueryParamOverride from '@gameday/utils/getQueryParamOverride';

const useContentApiOverride = getQueryParamOverride('useContentApi');

const getLanguage = (state) => state.config?.language;
const getDeviceInteraction = (state) => state.config?.deviceInteraction;
const getCurrentPlayData = (state) => {
    const currentPlay = state.play?.currentPlay || {};
    return {
        currentPlayIndex: currentPlay.atBatIndex,
        currentPlayEventsNumber: currentPlay.playEvents?.length,
        currentPlayResult: currentPlay.result
    };
};

const getAllPlays = (state) => {
    return state.play?.allPlays || [];
};
const getAllPlayMetrics = (state) => state.play?.allPlayMetrics || [];
const getPlayerMap = (state) => state.play?.playerMap || {};
const getTeamMap = (state) => state.play?.teamMap;
const getKeyMoments = (state) => state.keymoments?.dataByIndex;
const getLoading = (state) => state.loading?.isLoading;
const getVideoMap = (state) => {
    return (useContentApiOverride ?? state.config?.useContentApi)
        ? state.content?.playVideoMap
        : state.contentGraph?.playVideoMap;
};
const getAbsConfig = (state) => state?.config?.absConfig;

// Special selector function for passing in the index.
const getPlayIndex = (state, playIndex) => playIndex;

const getPlayStateHelper = createSelector([
    getPlayIndex,
    getLanguage,
    getDeviceInteraction,
    getCurrentPlayData,
    getAllPlays,
    getAllPlayMetrics,
    getTeamMap,
    getKeyMoments,
    getLoading,
    getVideoMap,
    getPlayerMap,
    getAbsConfig
],
(
    playIndex,
    language,
    deviceInteraction,
    currentPlay,
    allPlays,
    allPlayMetrics,
    teams,
    keymoments,
    isLoading,
    playVideoMap,
    playerMap,
    absConfig
) => ({
    playData: allPlays[playIndex],
    playMetrics: allPlayMetrics[playIndex],
    teams,
    playVideoMap,
    keymoments,
    isLoading,
    ...currentPlay,
    language,
    deviceInteraction,
    playerMap,
    absConfig
})
);

export const getPlayState = playIndex => state => getPlayStateHelper(state, playIndex);
